import { render, staticRenderFns } from "./GlobalModals.vue?vue&type=template&id=5b027b1b&scoped=true&"
import script from "./GlobalModals.vue?vue&type=script&lang=js&"
export * from "./GlobalModals.vue?vue&type=script&lang=js&"
import style0 from "./GlobalModals.vue?vue&type=style&index=0&id=5b027b1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b027b1b",
  null
  
)

/* custom blocks */
import block0 from "./GlobalModals.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

component.options.__file = "GlobalModals.vue"
export default component.exports